import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import { ACCOUNT_PATH, addAccount } from '../../api/accountApi'

const AccountAddPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const [newEntity, setNewEntity] = useState({
        code: "",
        name: "",
        description: ""
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${ACCOUNT_PATH}`, true)

    const onClickSubmit = () => {
        addAccount(newEntity)
            .then(res => {
                closeTab()
                toast.success('Hesap kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Hesap</label>
                <Input
                    label='Hesap Kodu'
                    name='code'
                    placeholder='Hesap kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Hesap Adı'
                    name='name'
                    placeholder='Hesap adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default AccountAddPage